import { css } from '@emotion/react';
import { theme } from '../../../theme';

const { background, primary } = theme.palette;
const { sm } = theme.breakpoints;
const { shadows } = theme;

export const relatedProductsWrapper = css`
  width: 100%;
  max-width: 1440px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 auto;

  & h4 {
    font-weight: 700;
    font-size: 45px;
    line-height: 52px;
    color: ${primary.main};
    margin-bottom: 35px;

    @media (max-width: ${`${sm}px`}) {
      font-size: 24px;
      line-height: 30px;
      text-align: left;
      width: 100%;
      margin-bottom: 25px;
    }
  }

  @media (max-width: ${`${sm}px`}) {
    background: ${background.gray};
    padding: 50px 25px;

    & div {
      background: ${background.gray};
    }

    & > div > div {
      border-bottom: 1px solid white;
    }

    & > div > div:last-of-type {
      border-bottom: none;
    }

    & > div > div .MuiAccordionSummary-root {
      font-size: 16px;
      line-height: 21px;
    }
  }
`;

export const relatedProductsCard = css`
  width: 257px;
  background: ${background.gray};
  border-radius: 15px;
  box-shadow: ${shadows[1]};
  padding: 10px 25px;
  margin-right: 13px;
  margin-bottom: 13px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & :last-of-type {
    margin-right: 0;
  }

  & p {
    color: ${primary.main};
    font-weight: 700;
    min-height: 42px;
    text-align: center;
  }
`;

export const relatedProductsImageWrapper = css`
  display: flex;
  height: 175px;
  min-width: 175px;
  align-items: center;
  justify-content: center;

  & img {
    width: 175px;
    height: 175px;
    object-fit: contain;
  }
`;

export const relatedProductsDivider = css`
  display: block;
  width: 100%;
  border-bottom: 1px solid white;
  margin: 15px 0;
`;

export const cardWrapper = css`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: ${`${sm}px`}) {
    display: none;
  }
`;

export const collapseWrapper = css`
  display: none;
  width: 100%;

  @media (max-width: ${`${sm}px`}) {
    display: block;

    & > div {
      display: flex;
      justify-content: space-between;
      align-items: center;

      & > p {
        font-weight: 700;
        font-size: 16px;
        line-height: 21px;
        color: ${primary.main};
        margin: 15px 0;
      }

      & > a {
        text-decoration: underline;
      }
    }
  }
`;

export const collapseIcon = css`
  text-decoration: underline;
  color: ${primary.dark};
  margin: 0;
  font-weight: bold;
`;
